module.exports = __webpack_public_path__ + "static/media/socketio.bd63aa6b.PNG";